import hasInitialized from '../actions/hasInitialized'
import appMounted from '../chains/appMounted'

function withInitialize(chain) {
  return [
    hasInitialized,
    {
      true: chain,
      false: [...appMounted, ...chain]
    }
  ]
}

export default withInitialize



// WEBPACK FOOTER //
// ./src/modules/app/factories/withInitialize.js